import _taggedTemplateLiteral from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
var Link = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  &:hover {\n    color: #2292f2;\n  }\n"])));
export default Link;